import { useQuery } from '@tanstack/react-query';
import { getTicketSummary } from '../lib/api';
import { useScope } from '../scope/scope';

export function useTicketSummary(enabled = true) {
  const { mspId } = useScope();
  return useQuery({ queryKey: ['scope', mspId, 'tickets', 'summary'], enabled,
    queryFn: ({ signal }) => getTicketSummary(mspId, signal), staleTime: 15_000, refetchInterval: 30_000 });
}
